import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class ComponentDescription extends BaseRootOption {
  static userInterfaceComponent = {
    label: "Description",
    component: inspectorTools.SIMPLE_INPUT,
    useVerticalOrientation: true,
    props: {
      inputType: "textarea",
    },
  };

  static defaultValue = "My new component";
}
